'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import UITextInput from 'UIComponents/input/UITextInput';
import refObject from 'UIComponents/utils/propTypes/refObject';
import { getTransferrableProps } from '../utils/getTransferrableProps';
const propTypes = {
  autoFocus: PropTypes.bool,
  inputRef: refObject.isRequired,
  value: PropTypes.string
};

class PropertyInputName extends PureComponent {
  getValue(value) {
    if (value == null) {
      return '';
    }

    return `${value}`;
  }

  render() {
    return /*#__PURE__*/_jsx(UITextInput, Object.assign({}, getTransferrableProps(this.props), {
      autoFocus: this.props.autoFocus,
      inputRef: this.props.inputRef,
      value: this.getValue(this.props.value),
      autoComplete: "off"
    }));
  }

}

PropertyInputName.propTypes = propTypes;
PropertyInputName.defaultProps = UITextInput.defaultProps;
export default PropertyInputName;